import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { toast } from '@grandvisionhq/common';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import { GET_STORE_BY_CODE } from '../../operations/queries/get-store-by-code.js';
import fromStoreByCodeQueryToStoreByCode from './adapters/fromStoreByCodeQueryToStoreByCode.js';

const useStoreByCode = (variables)=>{
    const { locale  } = useIntl();
    const [query, queryState] = useLazyQuery(GET_STORE_BY_CODE, {
        variables,
        context: {
            forwardHeaders: {
                'Accept-Language': locale
            }
        },
        errorPolicy: 'all',
        onError (error) {
            toast.failed('stores.page.search.getStoreByCode.error');
            console.error('Failed to fetch store by code: ', error);
        }
    });
    var _data;
    const { store  } = (_data = queryState.data) !== null && _data !== void 0 ? _data : {};
    const data = React.useMemo(()=>fromStoreByCodeQueryToStoreByCode(store)
    , [
        store
    ]);
    return React.useMemo(()=>[
            query,
            swcHelpers.objectSpread({}, queryState, {
                data
            })
        ]
    , [
        data,
        queryState,
        query
    ]);
};
var useStoreByCode$1 = useStoreByCode;

export { useStoreByCode$1 as default };
//# sourceMappingURL=use-store-by-code.js.map
